import { render, staticRenderFns } from "./DebtorPortalVerify.vue?vue&type=template&id=59795c6d"
import script from "./DebtorPortalVerify.vue?vue&type=script&lang=ts"
export * from "./DebtorPortalVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports